import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime)
dayjs.locale(ja); //日本表記にする.

export default dayjs;
